<ng-container *transloco="let t; read: 'findMyAgent.results'">
  <div class="flex flex-col items-center">
    <h3 class="text-heading-2 self-start md:self-center">{{ t('table.title') }}</h3>
    <p class="text-steel-80 self-start md:self-center">{{ t('table.subtitle') }}</p>

    <mat-button-toggle-group
      class="xs:w-fit my-8 w-full"
      [formControl]="localityControl"
      [hideSingleSelectionIndicator]="true"
      (valueChange)="seletedLocality.emit($event)">
      <mat-button-toggle class="xs:!px-4 w-full" [value]="locality.value" data-id="your-suburb">{{
        locality.label.length > 13 ? t('your-suburb') : locality.label
      }}</mat-button-toggle>
      <mat-button-toggle class="w-full md:!px-4" [value]="overallValue" data-id="all-suburbs">{{ t('overall') }}</mat-button-toggle>
    </mat-button-toggle-group>
  </div>
  <div>
    <ng-scrollbar
      orientation="horizontal"
      trackClass="!bg-blue-10 !h-2"
      thumbClass="!bg-blue-50 !h-2">
      <table class="w-full table-auto">
        <tr>
          <th class="w-14 md:w-[250px]"></th>
          @for (stat of showOverallStats ? agents[0].overallStatistics : agents[0].locationStatistics; track stat) {
            <td class="px-2 md:px-4">
              <div class="h-6">
                <rma-icon [glyph]="stat.icon" />
              </div>
              <span class="text-steel-70 whitespace-nowrap text-xs">{{ t(stat.type) }}</span>
            </td>
          }
        </tr>
        @for (agent of agents; track agentsTrackBy($index, agent)) {
          <tr class="border-steel-20 border-y py-2">
            <td class="border-steel-20 border-r py-2 pr-4 md:border-r-0">
              <button class="text-left" (click)="agentSelected.emit(agent.profileCode)" type="button">
                <rma-result-profile
                  class="hidden md:block"
                  [avatar]="agent.branding.avatarImage"
                  [name]="agent.name"
                  [agencyName]="agent.agencyName"
                  [starRating]="agent.overallStats.averageStarRating ?? 0"
                  [totalReviews]="agent.overallStats.totalReviewCount ?? 0"
                  [showRatingSummary]="false" />
                <rma-profile-avatar
                  class="aspect-square h-12 w-12 md:hidden"
                  [avatar]="agent.branding.avatarImage"
                  [lazyLoad]="false"
                  profileType="Individual"
                  target="_blank" />
              </button>
            </td>
            @for (stat of showOverallStats ? agent.overallStatistics : agent.locationStatistics; track stat) {
              <td class="px-2 text-2xl font-bold md:px-4">
                @if (stat.isCurrency) {
                  <span>
                    {{ stat.value | shortNumber: (stat.value ?? 0 > 1_000_000 ? 1 : 0) : true }}
                  </span>
                } @else {
                  <span>{{ stat.value | number: '1.0-0' }}</span>
                }
              </td>
            }
          </tr>
        }
      </table>
      <div class="h-6"></div>
    </ng-scrollbar>
  </div>
</ng-container>
